import * as React from 'react';

import './shared-access-product-grid.scss';

type Props = {
  children: React.ReactNode | undefined | null
};

const SharedAccessProductGrid = (
  {
    children
  }: Props
): JSX.Element => (
  <div className="shared-access-product-grid">
    {children}
  </div>
);

export default SharedAccessProductGrid;
